import DeleteIcon from "@mui/icons-material/Delete";
import Logger from "../../../services/Logger";
import SaveIcon from '@mui/icons-material/Save';
import { Box, Grid, Paper, TextField, Tooltip } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import IconButton from "@mui/material/IconButton";
import Switch from "@mui/material/Switch";
import moment from "moment";
import React, { useEffect, useState } from "react";
import ConfirmDialog from "../../components/ConfirmDialog";
import CustomFabs from "../../components/CustomFabs";
import CustomSnackbar from "../../components/CustomSnackbar";
import GenreDialog from "./GenreCreateDialog";
import GenreService from "./GenreServie";
import GenreTree from "./GenreTree";

export default function GenreMain() {
    const [formData, setFormData] = useState({
        name: "",
        displayOrder: "",
        guardianId: "",
        description: "",
        active: false,
        orderLevel: "",
        parentGenreId: "",
    });
    const [openCreate, setOpenCreate] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);

    const [selectedGenreId, setSelectedGenreId] = useState();
    const [reload, setReload] = useState();

    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [severity, setSeverity] = useState(false);
    const [message, setMessage] = useState("");

    useEffect(() => {
        GenreService.requestGenre(selectedGenreId).then((r) => {
            // Logger.log(r);

            setFormData({
                name: r.name,
                displayOrder: r.displayOrder,
                guardianId: r.guardianId || "",
                active: r.active,
                orderLevel: r.orderLevel,
                description: r.description,
            });
        });
    }, [selectedGenreId]);

    const handleFormChange = (event) => {
        const { name, value, type, checked } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleSnackBar = (severity, message) => {
        setOpenSnackbar(true);
        setSeverity(severity);
        setMessage(message);
    };

    const handleUpdate = () => {
        const { name, displayOrder, guardianId, description, active } = formData;
        GenreService.updateGenre(selectedGenreId, name, displayOrder, guardianId, description, active).then(() => {
            setReload(moment());
            handleSnackBar("info", "updated");
        });
    };

    const handleDelete = (id) => {
        GenreService.deleteGenre(id)
            .then(() => {
                handleSnackBar("warning", "deleted");
                setReload(moment());
            })
            .catch((err) => {
                handleSnackBar("error", err.message || "Failed to delete genre");
            });
    };

    return (
        <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
                <Grid size={{ xs: 6 }}>
                    <Paper elevation={3} sx={{ height: "100%", p: 2 }}>
                        <GenreTree callback={(id) => setSelectedGenreId(id)} parentReload={reload} />
                    </Paper>
                </Grid>
                <Grid size={{ xs: 6 }} sx={{ gap: 2 }}>
                    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                        <Tooltip title="Delete genre">
                            <IconButton color="warning" onClick={() => setOpenDelete(true)}>
                                <DeleteIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Update genre">
                            <IconButton color="primary" onClick={() => handleUpdate()}>
                                <SaveIcon />
                            </IconButton>
                        </Tooltip>
                    </Box>
                    <TextField
                        margin="dense"
                        label="Genre ID"
                        fullWidth
                        variant="standard"
                        name="genreId"
                        value={selectedGenreId || ""}
                        slotProps={{
                            input: {
                                readOnly: true,
                            },
                        }}
                        helperText="This is the unique identifier for the genre"
                    />
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Genre Name"
                        fullWidth
                        variant="standard"
                        name="name"
                        value={formData.name}
                        onChange={handleFormChange}
                    />
                    <TextField
                        margin="dense"
                        label="Display Order"
                        fullWidth
                        type="number"
                        variant="standard"
                        name="displayOrder"
                        value={formData.displayOrder}
                        onChange={handleFormChange}
                    />
                    <TextField
                        margin="dense"
                        label="Guardian ID"
                        fullWidth
                        variant="standard"
                        name="guardianId"
                        value={formData.guardianId}
                        onChange={handleFormChange}
                    />
                    <TextField
                        margin="dense"
                        label="Description"
                        fullWidth
                        variant="standard"
                        multiline
                        rows={4}
                        name="description"
                        value={formData.description}
                        onChange={handleFormChange}
                    />
                    <FormGroup>
                        <FormControlLabel
                            control={<Switch name="active" checked={formData.active ? true : false} onChange={handleFormChange} />}
                            label="Active"
                        />
                    </FormGroup>   </Grid>
            </Grid>

            <CustomFabs tabIndex={0} callback={() => setOpenCreate(true)} />

            <ConfirmDialog
                open={openDelete}
                setOpen={setOpenDelete}
                title="Delete Genre"
                message={[
                    "Are you sure you want to permanently delete this genre? This action cannot be undone.",
                    "Related topics and puzzles will be reset."
                ]}
                targetId={selectedGenreId}
                callback={handleDelete}
            />

            <CustomSnackbar open={openSnackbar} setOpen={setOpenSnackbar} severity={severity} message={message} />

            <GenreDialog
                open={openCreate}
                setOpen={setOpenCreate}
                callback={() => {
                    handleSnackBar("info", "added");
                    setReload(moment().unix());
                }}
            />
        </Box>
    );
}
